var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dangerZoneId && _vm.data)?_c('div',[_c('AppMapMouseEditor',{key:_vm.version,attrs:{"readonly":"","value":_vm.data.location_amap || _vm.data.location_point}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }